import { Component, HostListener, ElementRef, Input } from '@angular/core';
declare var $: any;

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
    @Input() enableMobile = true;
    @Input() isButton = true;
    @Input() eventOpen: boolean = true;
    @Input() min_width: String = '19rem';
    @Input() closeOnClick: any = false;
    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (this.closeOnClick || (this.showMenu && !this.eRef.nativeElement.contains(event.target))) {
            this.showMenu = false;
            this.closeOnClick = false;
        }
        // if (!this.eventOpen) {
        //   console.log('Evento bloqueado: ', this.eventOpen);
        //   this.showMenu = false;
        // }
    }
    public showMenu = false;
    constructor(
        private eRef: ElementRef
    ) {
    }

    openMenu() {
        this.showMenu = true;
    }

    closeMenu() {
        this.showMenu = false;
    }

}
